// SPDX-License-Identifier: AGPL-3.0-or-later

import {makePersistent} from '@app/features/platform/utils/MobXPersistence';
import {makeAutoObservable} from 'mobx';

// The 3D room's way of teaching its keys: the first-visit intro (once per device), the "?" shortcut card and the
// picker with every movement, and whether the action bar is tucked away. Only `introSeen` and `dockHidden` are kept;
// the card and the picker start closed in every session.
class RoomShortcutGuideState {
	introSeen = false;
	cardOpen = false;
	moreOpen = false;
	// The action bar is tucked away to a small tab; its keys work on.
	dockHidden = false;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
		void makePersistent(this, 'RoomShortcutGuide', ['introSeen', 'dockHidden']);
	}

	get introPending(): boolean {
		return !this.introSeen;
	}

	dismissIntro(): void {
		this.introSeen = true;
	}

	toggleCard(): void {
		this.cardOpen = !this.cardOpen;
		this.moreOpen = false;
		this.introSeen = true;
	}

	toggleMore(): void {
		this.moreOpen = !this.moreOpen;
		this.cardOpen = false;
	}

	toggleDockHidden(): void {
		this.dockHidden = !this.dockHidden;
		this.moreOpen = false;
	}

	// Esc: true when something was open.
	closeAll(): boolean {
		const open = this.cardOpen || this.moreOpen;
		this.cardOpen = false;
		this.moreOpen = false;
		return open;
	}
}

export default new RoomShortcutGuideState();
